<template>
  <div
    class="tile-list-close"
  >
    <close-button big @click="$emit('click')"/>
  </div>
</template>

<script>
import CloseButton from '@/components/CloseButton'

export default {
  components: {
    CloseButton
  }
}
</script>

<style lang="scss" scoped>
  .tile-list-close {
    @include hide-down(md);

    position: fixed;
    top: 80px;
    right: 28px;

    z-index: z(tiles) + 1;

    @include media-up(xl) {
      top: 58px;
      right: 48px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Map/TileListClose.vue